function init() {
	'use strict';

	document.body.addEventListener( 'click', function( event ) {
		const button = event.target.closest( '.card .btn.view-details' );
		if ( ! button ) {
			return;
		}

		button.innerHTML = button.classList.contains( 'collapsed' )
			? button.innerHTML.replace( /More/g, 'Less' )
			: button.innerHTML.replace( /Less/g, 'More' );
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	init();
}
